import type { PaymentMethodSummary } from './types.ts'

const BRANDS: Record<string, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  amex: 'American Express',
  'american-express': 'American Express',
  discover: 'Discover',
  'diners-club': 'Diners Club',
  jcb: 'JCB'
}

/**
 * Names a payment method for display, without the expiry.
 * @param method - The brand, type and last four.
 * @returns For example "Visa ending in 4242".
 */
export function describeMethod(
  method: Pick<PaymentMethodSummary, 'brand' | 'last4' | 'paymentType'>
): string {
  if (method.paymentType === 'ach')
    return `Bank account ending in ${method.last4}`
  const brand = method.brand
    ? (BRANDS[method.brand.toLowerCase()] ?? method.brand)
    : 'Card'
  return `${brand} ending in ${method.last4}`
}

/**
 * Formats a card expiry for display.
 * @param expMonth - The month, 1 to 12.
 * @param expYear - The four-digit year.
 * @returns For example "Expires 01/2031", or an empty string when unknown.
 */
export function describeExpiry(
  expMonth: number | null,
  expYear: number | null
): string {
  if (expMonth === null || expYear === null) return ''
  return `Expires ${String(expMonth).padStart(2, '0')}/${expYear}`
}
